(function(){
  function init(section){
    const id = section.getAttribute('data-section-id');
    const input = document.getElementById(`cafc-${id}-search`);
    const result = document.getElementById(`cafc-${id}-result`);
    const clearBtn = document.getElementById(`cafc-${id}-clear`);
    const list = document.getElementById(`cafc-${id}-suggestions`);

    if(!input || !result || !clearBtn || !list) return;

    const dayMap = {
      "Tuesday": ["Boston","Brighton","Brookline","Cambridge","Canton","Charlestown","Chelsea","Dedham","Dorchester","Everett","Hyde Park","Jamaica Plain","Malden","Medford","Melrose","Milton","Norwood","Revere","Roxbury","Saugus","Somerville","West Roxbury","Winthrop"],
      "Wednesday": ["Arlington","Auburndale","Bedford","Belmont","Burlington","Concord","Framingham","Lexington","Lincoln","Natick","Needham","Newton","Reading","Stoneham","Sudbury","Waban","Wakefield","Waltham","Watertown","Wayland","Wellesley","Weston","Winchester","Woburn"],
      "Thursday": ["Amesbury","Andover","Beverly","Boxford","Byfield","Danvers","Essex","Georgetown","Gloucester","Groveland","Hamilton","Ipswich","Lynn","Lynnfield","Manchester","Manchester by the Sea","Marblehead","Middleton","Newbury","Newburyport","North Reading","Peabody","Rockport","Rowley","S Hamilton","Salem","Salisbury","Swampscott","Topsfield","Wenham","West Newbury"],
      "Friday": ["Acton","Ayer","Billerica","Bolton","Boxborough","Carlisle","Chelmsford","Groton","Harvard","Littleton","Maynard","Pepperell","Stow","Westford","Wilmington"]
    };

    const townToDay = {};
    Object.entries(dayMap).forEach(([day, towns]) => {
      towns.forEach(t => { townToDay[t.toLowerCase()] = day; });
    });

    function setResult(msg, day){
      if(day){
        result.innerHTML = `<strong>${escapeHtml(capitalizeWords(msg))}</strong> → <span>${day}</span> <span class="tag">Home Delivery</span>`;
      } else {
        result.textContent = msg;
      }
    }

    function showSuggestions(matches){
      list.innerHTML = '';
      if(!matches.length){
        list.style.display = 'none';
        return;
      }
      matches.slice(0, 8).forEach((m, idx) => {
        const li = document.createElement('li');
        li.textContent = capitalizeWords(m);
        li.setAttribute('role', 'option');
        li.setAttribute('id', `opt-${idx}`);
        li.addEventListener('click', () => {
          input.value = m;
          handleLookup();
          list.style.display = 'none';
        });
        list.appendChild(li);
      });
      list.style.display = 'block';
    }

    function handleLookup(){
      const q = (input.value || '').trim().toLowerCase();
      if(!q){
        result.textContent = '';
        clearBtn.style.display = 'none';
        list.style.display = 'none';
        return;
      }

      clearBtn.style.display = 'block';

      if(townToDay[q]){
        setResult(q, townToDay[q]);
        showSuggestions([]);
        return;
      }

      const allTowns = Object.keys(townToDay);
      const starts = allTowns.filter(t => t.startsWith(q));
      const contains = allTowns.filter(t => !t.startsWith(q) && t.includes(q));
      const suggestions = [...starts, ...contains];

      if(suggestions.length){
        setResult('Did you mean one of these?', null);
        showSuggestions(suggestions);
      } else {
        setResult('No match found. Try another spelling or nearby town.', null);
        showSuggestions([]);
      }
    }

    function capitalizeWords(str){
      return str.replace(/\b\w/g, c => c.toUpperCase());
    }

    function escapeHtml(str){
      return String(str).replace(/[&<>"]/g, s => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;'
      }[s] || s));
    }

    input.addEventListener('input', handleLookup);
    input.addEventListener('focus', handleLookup);
    clearBtn.addEventListener('click', () => {
      input.value = '';
      handleLookup();
      input.focus();
    });

    let activeIndex = -1;
    input.addEventListener('keydown', (e) => {
      const items = Array.from(list.querySelectorAll('li'));
      if(!items.length) return;

      if(e.key === 'ArrowDown'){
        e.preventDefault();
        activeIndex = (activeIndex + 1) % items.length;
        updateActive(items);
      } else if(e.key === 'ArrowUp'){
        e.preventDefault();
        activeIndex = (activeIndex - 1 + items.length) % items.length;
        updateActive(items);
      } else if(e.key === 'Enter'){
        if(activeIndex >= 0){
          e.preventDefault();
          items[activeIndex].click();
        }
      }
    });

    function updateActive(items){
      items.forEach((el, i) => el.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'));
      if(items[activeIndex]){
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    const params = new URLSearchParams(window.location.search);
    const t = params.get('town');
    if(t){
      input.value = t;
      handleLookup();
    }
  }

  function onLoad(){
    document.querySelectorAll('.cafc-delivery-finder').forEach(init);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.cafc-delivery-finder');
    if(section) init(section);
  });

  document.addEventListener('click', function(e){
    const summary = e.target.closest('.cafc-full-list > summary');
    if(summary){
      const details = summary.parentElement;
      setTimeout(() => {
        if(typeof details.open === 'undefined' || (summary.getAttribute('aria-expanded') && summary.getAttribute('aria-expanded') === 'false')){
          details.open = !details.open;
        }
      }, 0);
    }
  }, true);
})();